<template>
  <div
    v-show="isActive"
    role="tabpanel"
    class="tab-pane card-body"
    :class="{ active: isActive, show: isActive }"
    :aria-hidden="!isActive"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BTab',
  inject: {
    btabs: { default: null }
  },
  props: {
    title: { type: String, default: '' },
    active: { type: Boolean, default: false }
  },
  data () {
    return {
      tabMeta: null
    }
  },
  computed: {
    isActive () {
      if (!this.tabMeta || !this.btabs) return false
      return this.tabMeta.index === this.btabs.activeIndex
    }
  },
  mounted () {
    if (!this.btabs) return
    this.tabMeta = this.btabs.registerTab({
      title: this.title,
      titleRender: () => this.$slots.title?.() ?? [],
      active: this.active
    })
  },
  beforeUnmount () {
    if (this.tabMeta?.uid && this.btabs) {
      this.btabs.unregisterTab(this.tabMeta.uid)
    }
  }
}
</script>
